export const FETCH_READING_RESULTS = {
    RAN: 'FETCH_RAN_RESULTS',
    DECODING: 'FETCH_DECODING_RESULTS',
    TRO: 'FETCH_TRO_RESULTS',
};

export const FETCH_READING_INTERPS = {
    RAN: 'FETCH_RAN_INTERPS',
    D8: 'FETCH_D8_INTERPS',
    D8_COMPOSITE: 'FETCH_D8_COMPOSITE_INTERPS',
    DECODING: 'FETCH_DECODING_INTERPS',
    MAZE: 'FETCH_MAZE_INTERPS',
};

export const FETCH_INTERNAL_CUTSCORES = {
    START: 'FETCH_INTERNAL_CUTSCORES_START',
    SUCCESS: 'FETCH_INTERNAL_CUTSCORES_SUCCESS',
    ERROR: 'FETCH_INTERNAL_CUTSCORES_ERROR',
};

export const FETCH_BURST_RESULTS_FOR_YEAR = {
    START: 'FETCH_BURST_RESULTS_FOR_YEAR_START',
    SUCCESS: 'FETCH_BURST_RESULTS_FOR_YEAR_SUCCESS',
    ERROR: 'FETCH_BURST_RESULTS_FOR_YEAR_ERROR',
};

export const FETCH_TRO_BOOK_DATA = {
    START: 'FETCH_TRO_BOOK_DATA_START',
    SUCCESS: 'FETCH_TRO_BOOK_DATA_SUCCESS',
    ERROR: 'FETCH_TRO_BOOK_DATA_ERROR',
};

export const REVERT_TRO_BOOK = {
    START: 'REVERT_TRO_BOOK_START',
    SUCCESS: 'UPDATE_TRO_RESULT',
    ERROR: 'REVERT_TRO_BOOK_ERROR',
};

export const PATCH_TRO_REMARKS = {
    START: 'PATCH_TRO_REMARKS_START',
    SUCCESS: 'UPDATE_TRO_RESULT',
    ERROR: 'PATCH_TRO_REMARKS_ERROR',
};

export const FETCH_TRO_AUDIO_DATA = {
    START: 'FETCH_TRO_AUDIO_DATA_START',
    SUCCESS: 'FETCH_TRO_AUDIO_DATA_SUCCESS',
    ERROR: 'FETCH_TRO_AUDIO_DATA_ERROR',
};

export const FETCH_INTERVENTIONS = {
    START: 'FETCH_INTERVENTIONS_START',
    SUCCESS: 'FETCH_INTERVENTIONS_SUCCESS',
    ERROR: 'FETCH_INTERVENTIONS_ERROR',
};

export const FETCH_HC_ACTIVITIES = {
    START: 'FETCH_HC_ACTIVITIES_START',
    SUCCESS: 'FETCH_HC_ACTIVITIES_SUCCESS',
    ERROR: 'FETCH_HC_ACTIVITIES_ERROR',
};

export const TRO_CONFIRMATION_POPUP = {
    SHOW: 'SHOW_TRO_CONFIRMATION_POPUP',
    CLOSE: 'CLOSE_TRO_CONFIRMATION_POPUP',
};

export const LEXILE_TOGGLE_STATE = {
    SET: 'SET_LEXILE_TOGGLE_STATE',
    CLEAR: 'CLEAR_LEXILE_TOGGLE_STATE',
};

export const FETCH_ALL_TRO_BOOKS_DATA = {
    START: 'FETCH_ALL_TRO_BOOKS_DATA_START',
    SUCCESS: 'FETCH_ALL_TRO_BOOKS_DATA_SUCCESS',
    ERROR: 'FETCH_ALL_TRO_BOOKS_DATA_ERROR',
};

export const FETCH_READING_OBSERVATIONS = {
    D8: 'FETCH_D8_OBSERVATIONS_SUCCESS',
    DECODING: 'FETCH_DECODING_OBSERVATIONS_SUCCESS',
};

export const INVALIDATE_D8_RESULT = {
    START: 'INVALIDATE_D8_RESULT_START',
    SUCCESS: 'INVALIDATE_D8_RESULT_SUCCESS',
    ERROR: 'INVALIDATE_D8_RESULT_ERROR',
};

export const FETCH_D8_RESULT_BY_ID = {
    START: 'FETCH_D8_RESULT_BY_ID_START',
    SUCCESS: 'FETCH_D8_RESULT_BY_ID_SUCCESS',
    ERROR: 'FETCH_D8_RESULT_BY_ID_ERROR',
};

export const REMOVE_D8_RESULT_AFTER_INVALIDATION = 'REMOVE_D8_RESULT_AFTER_INVALIDATION';

export const SECOND_ATTEMPT_BULK_INVALIDATION_MODAL = {
    SHOW: 'SHOW',
    HIDE: 'HIDE',
};

export const INVALIDATE_D8_SECOND_ATTEMPT_RESULTS = {
    START: 'INVALIDATE_D8_SECOND_ATTEMPT_RESULTS_START',
    SUCCESS: 'INVALIDATE_D8_SECOND_ATTEMPT_RESULTS_SUCCESS',
    ERROR: 'INVALIDATE_D8_SECOND_ATTEMPT_RESULTS_ERROR',
};
